export default __webpack_public_path__ + "static/media/gym interior.69131d65.jpg";